export const blockIconsPlacesPool = (
	<span className='material-symbols-outlined'>pool</span>
);
